import { isPlatformBrowser } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core'
import { ApiService } from 'src/app/core/services/api.service'
import { ChatState } from 'src/app/core/services/chat.service'
import { PageService } from 'src/app/core/services/page.service'
import { SESSION_TIMER_MINUTES } from '../options-utils/modal-shared'

@Component({
    selector: 'app-modal-options-error',
    templateUrl: './modal-options-error.component.html',
    styleUrls: ['../modal-options.component.scss', './modal-options-error.component.scss'],
    standalone: false
})
export class ModalOptionsErrorComponent implements OnInit {
  @Output() closeError: EventEmitter<any> = new EventEmitter()
  @Output() closeModal: EventEmitter<any> = new EventEmitter()
  @Input() breakpoints: any = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }

  constructor(
    public page: PageService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    this.cdr.detectChanges()
  }

  closeErrorEvent() {
    this.closeError.emit()
  }
}
